import { Outlet } from 'react-router-dom'

import {
  DesktopNavigation,
  MobileNavigation,
} from '../../components/Navigation'

export default function SettingsLayout() {
  return (
    <>
      <main className="bg-green-950 text-white min-h-screen">
        <div className="flex-1">
          <DesktopNavigation />
          <div className="p-4 lg:p-6 max-w-xl mx-auto pb-28 md:pb-6">
            <Outlet />
          </div>
        </div>
      </main>
      <MobileNavigation />
    </>
  )
}
